export const getStorelogEnabled = () => {
  if (typeof window === 'undefined') return false;
  try {
    const storage = window.localStorage;
    if (!storage) return false;
    const flag = storage.getItem('storelog');
    return ['1', 'true', 'yes', 'on'].includes((flag || '').toLowerCase());
  } catch (err) {
    return false;
  }
};
